// extracted by mini-css-extract-plugin
export default {"upNavigation":"UpNavigation_upNavigation__NyQqT","upIcon":"UpNavigation_upIcon__PnyA6","upNavigationText":"UpNavigation_upNavigationText__l3hCi"};